"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TractableDefaultTheme = void 0;
var size_1 = require("./size");
var colour_1 = require("./colour");
exports.TractableDefaultTheme = {
    global: {
        body: {
            fontFamily: 'IBM Plex Sans, "Segoe UI", -apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif;',
        },
    },
    colour: colour_1.Colour,
    iconSize: size_1.IconSize,
};
